import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import Stepper from '@mui/material/Stepper';
import StepButton from '@mui/material/StepButton';

import { useJobStepper } from 'src/pages/create-job/context/job-stepper-context-provider';

const steps = ['Enter Role Name', 'Add Job Description', 'Evaluation Criteria'];

export function HorizontalLinearStepper() {
  const { activeStep, handleStepClick, completed } = useJobStepper();

  return (
    <Box sx={{ width: 1 }}>
      <Stepper nonLinear activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={label} completed={completed[index]}>
            <StepButton
              onClick={() => handleStepClick(index)}
              sx={{
                width: 1,
                px: { xs: 0.25, sm: 0.75, md: 1 },
                '& .MuiStepLabel-label': {
                  display: 'block',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: { xs: 70, sm: 100, md: 'none' },
                  fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.875rem' },
                },
              }}
            >
              {label}
            </StepButton>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
